// extracted by mini-css-extract-plugin
export default {"headerElement":"FooterHeader_headerElement__Ceu+I","phoneText":"FooterHeader_phoneText__lGIm5","link":"FooterHeader_link__7Fp-N"};